"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M12.9703 10.3461c.5172 0 .9364-.4059.9364-.9065 0-.5006-.4192-.9065-.9364-.9065s-.9364.4059-.9364.9065c0 .5006.4192.9065.9364.9065z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8269 4c-2.057 0-3.7026 1.4193-5.0816 2.708l1.3763 1.3322L2 11.5867 9.4362 21l2.7825-4.3097h6.8148c1.6383 0 2.9665-1.2856 2.9665-2.8716 0-.7092-.2708-1.3938-.7627-1.9213-1.071-1.1485-3.5557-3.8062-4.4906-4.7435.8134-.666 2.1683-.6742 3.1414-.4576.6692.149 1.4731-.116 1.4926-.8868.0689-2.7173-7.1781-1.526-8.6109-1.0221C12.2159 4.4512 11.2122 4 9.8268 4zM7.4727 6.7843c.6749-.4759 1.4952-.9714 2.3542-.9714 1.1129 0 1.8655.3874 2.6168 1.066.9041-.375 1.808-.6854 2.7892-.8181-.5772.6527-.6238 1.5843.0184 2.206.7107.688 3.4265 3.5914 4.5958 4.8453.6124.6567.12 1.7653-.8136 1.7653h-7.8528l-1.8995 2.942-4.737-5.9964 4.306-3.7051-1.3775-1.3336z"
  })];
};

exports.default = _default;